// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kD4gOI {
  width: 100%;
  max-width: 400px;
  min-height: 400px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media (max-width: 900px) {
  .kD4gOI {
    min-height: 400px;
    padding: 0;
  }
}

.oVsQil {
  max-width: 340px;
  width: 100%;
  border-top: var(--login-card-wrapper-border, 4px);
  border-radius: 0 0 8px 8px;
  background: var(--background-white);
  box-shadow: var(--card-box-shadow);
  padding: 36px;
  border-top: 4px solid var(--surface-primary-medium);
}

.i6aglx {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TwoFactorSelect/TwoFactorSelect.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iDAAiD;EACjD,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".container {\n  width: 100%;\n  max-width: 400px;\n  min-height: 400px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 900px) {\n  .container {\n    min-height: 400px;\n    padding: 0;\n  }\n}\n\n.card {\n  max-width: 340px;\n  width: 100%;\n  border-top: var(--login-card-wrapper-border, 4px);\n  border-radius: 0 0 8px 8px;\n  background: var(--background-white);\n  box-shadow: var(--card-box-shadow);\n  padding: 36px;\n  border-top: 4px solid var(--surface-primary-medium);\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kD4gOI`,
	"card": `oVsQil`,
	"loadingContainer": `i6aglx`
};
module.exports = ___CSS_LOADER_EXPORT___;
